import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Dialog } from 'primeng/dialog';
import { FloatLabel } from 'primeng/floatlabel';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import VehicleModel from '../../../../../../types/vehicle-model/VehicleModel';
import { VehicleModelService } from '../../../../services/vehicle-model.service';

@Component({
    selector: 'app-add-vehicle-models-dialog',
    imports: [
        Dialog,
        TableModule,
        FormsModule,
        InputTextModule,
        CardModule,
        FloatLabel,
        IconField,
        InputIcon,
        Button,
    ],
    templateUrl: './add-vehicle-models-dialog.component.html',
    styleUrls: [ './add-vehicle-models-dialog.component.scss' ]
})
export class AddVehicleModelsDialogComponent implements OnChanges {

    @Input() public visible: boolean = false;
    @Input() public sampleId: number | null = null;
    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public vehicleModelsAdded = new EventEmitter<void>();

    public loading = false;
    public vehicleModels: VehicleModel[] = [];
    public totalRecords: number = 0;
    public rows: number = 10;
    public search: string = '';
    public page: number = 0;
    public selectedVehicleModels: VehicleModel[] = [];

    constructor(private vehicleModelService: VehicleModelService, private messageService: MessageService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && this.visible) {
            // Load vehicle models when the dialog is opened
            this.loadVehicleModels({ first: 0, rows: this.rows });
            this.selectedVehicleModels = [];
        }
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadVehicleModels(event: TableLazyLoadEvent) {
        this.loading = true;

        const page = ( event.first || 0 ) / ( event.rows || this.rows );
        const size = event.rows || this.rows;

        this.vehicleModelService
            .getVehicleModels(this.search, page, size, this.sampleId ? [ this.sampleId ] : [])
            .then((data) => {
                this.vehicleModels = data.content;
                this.totalRecords = data.page.totalElements;
                this.page = page;
                this.loading = false;
            })
            .catch((error) => {
                console.error('Failed to load vehicle models:', error);
                this.loading = false;
            });
    }

    public onSearch(event: any) {
        this.search = event.target.value;
        this.loadVehicleModels({ first: 0, rows: this.rows });
    }

    public onSelectionChange(event: any) {
        this.selectedVehicleModels = event;
    }

    public addVehicleModels() {
        if (this.sampleId !== null && this.selectedVehicleModels.length > 0) {
            const vehicleModelIds = this.selectedVehicleModels.map((model) => model.id);
            this.loading = true;
            this.vehicleModelService
                .addVehicleModelsToSample(this.sampleId, vehicleModelIds)
                .then(() => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Vehicle models added to sample',
                        life: 3000,
                    });
                    this.vehicleModels = [];
                    this.selectedVehicleModels = [];
                    this.vehicleModelsAdded.emit();
                    this.close();
                })
                .catch((error) => {
                    console.error('Failed to add vehicle models to sample:', error);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
